import { getCartFirstAddKey } from './cartTimingStorage'
import { logKlaviyoCartDebug } from './logKlaviyoCartDebug'
import { isKlaviyoCartTrackingEnabled } from './isKlaviyoCartTrackingEnabled'

export function trackCartCheckoutTiming(cart, customer) {
  if (!isKlaviyoCartTrackingEnabled()) return

  if (!cart?.id || !customer?.email || typeof window === 'undefined' || !window.klaviyo) {
    return
  }

  const firstAdd = localStorage.getItem(getCartFirstAddKey(cart.id))
  if (!firstAdd) return

  const seconds = (Date.now() - new Date(firstAdd).getTime()) / 1000
  const minutes = Math.round(seconds / 60)
  const value = parseFloat(cart?.cost?.totalAmount?.amount ?? '0')

  try {
    const identifyPayload = {
      email: customer.email,
      last_time_to_checkout_minutes: minutes,
    }

    const trackPayload = {
      time_to_checkout_seconds: Math.round(seconds),
      time_to_checkout_minutes: minutes,
      $value: value,
      cart_id: cart.id,
    }

    window.klaviyo.identify(identifyPayload)
    window.klaviyo.track('Headless Checkout Started', trackPayload)

    logKlaviyoCartDebug('trackCartCheckoutTiming', { identifyPayload, trackPayload })
  } catch (error) {
    console.warn('[Klaviyo] trackCartCheckoutTiming failed', error)
  }
}
